import { render } from "./MainTitle.vue?vue&type=template&id=6beedaa6&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"

import "./MainTitle.vue?vue&type=style&index=0&id=6beedaa6&scoped=true&lang=css"

import exportComponent from "D:\\Data\\Bibliothèque\\Téléchargements\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6beedaa6"]])

export default __exports__